export default {
  UNANSWERED: '',
  DECLINED: 10,
  ACCEPTED: 20,
};
